/**
 * DBS-351: copies text to the clipboard. Uses the Clipboard API, falling back to a hidden textarea and execCommand
 * for browsers that refuse it. Resolves false when neither works, so the caller can show the text instead.
 */
export const copyToClipboard = async (text: string, nav: Pick<Navigator, 'clipboard'> | undefined = navigator, doc: Document = document): Promise<boolean> => {
  try {
    if (nav?.clipboard?.writeText) {
      await nav.clipboard.writeText(text)
      return true
    }
  } catch {
    // fall through to the textarea
  }
  try {
    const area = doc.createElement('textarea')
    area.value = text
    area.setAttribute('readonly', '')
    area.style.position = 'fixed'
    area.style.opacity = '0'
    doc.body.appendChild(area)
    area.select()
    const copied = doc.execCommand('copy')
    doc.body.removeChild(area)
    return copied
  } catch {
    return false
  }
}
